module.exports = __webpack_public_path__ + "img/1566385702.9bd33254.jpg";